
module.exports = {
  createGroup: "admin",
  removeGroup: "admin",
  modifyUserProfile: "admin",

  modifyUserPseudo: "admin",
  modifyUserSettings: "admin",
  modifyUserRole: "admin",

  removeUser: "admin",

  modifyPseudo: "user",
  modifyAvatar: "user",

  createService: "admin",
  removeService: "admin",
  modifyService: "admin",

  createRole: "manager",
  removeRole: "manager",
  modifyRole: "manager",

  createMember: "manager",
  removeMember: "manager",
  modifyMemberData: "manager",

  modifyGroupName: "manager",
  modifyGroupUsers: "manager",
  modifyGroupRoles: "manager",
  modifyGroupProfiles: "manager",

  createProject: "manager",
  removeProject: "manager",
  modifyProject: "manager",

  modifyProjectApps: "manager",
  modifyProjectUsers: "manager",

  createProfile: "manager",
  removeProfile: "manager",
  modifyProfile: "manager",

  createAPIs: "admin",
  modifyAPIs: "admin",
  removeAPIs: "admin",

  createApp: "admin",
  removeApp: "admin",
  modifyApp: "admin",

  createLicence: "admin",
  removeLicence: "admin",
  modifyLicence: "admin",

  createTheme: "admin",
  removeTheme: "admin",
  modifyTheme: "admin",

  createInvitation: "manager",
  removeInvitation: "manager",
  modifyInvitation: "manager"

};
